import { useAppContext } from 'src/context/store/app-provider';
import {
  type AlshayaVariant,
  decideAlshaya,
  decideCard,
  decidePromo,
  decideWebview,
  type WidgetDecisionInput,
} from 'src/domain/widget-decisions';

export const useWidgetDecisionInput = (): WidgetDecisionInput => {
  const {
    currency,
    formattedCurrency,
    installmentsCount,
    installmentsCountRaw,
    offers,
    experiments,
  } = useAppContext();

  return {
    currency,
    formattedCurrency,
    installmentsCount,
    installmentsCountRaw,
    offers,
    experiments,
  };
};

export const usePromoDecision = () => decidePromo(useWidgetDecisionInput());

export const useCardDecision = () => decideCard(useWidgetDecisionInput());

export const useWebviewDecision = () => decideWebview(useWidgetDecisionInput());

export const useAlshayaDecision = (variant: AlshayaVariant) => {
  const { currency, price, minPrice } = useAppContext();

  return decideAlshaya({ variant, currency, price, minPrice });
};
